import { useEffect, useState } from 'react';

/**
 * Tracks which section occupies the middle of the viewport so the nav can
 * highlight it. The centre-biased rootMargin means a section only becomes
 * active once it is genuinely the one being read.
 */
const useScrollSpy = (sectionIds, defaultId) => {
  const [activeSection, setActiveSection] = useState(defaultId ?? sectionIds[0]);

  useEffect(() => {
    const observers = sectionIds
      .map((id) => {
        const el = document.getElementById(id);
        if (!el) return null;
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) setActiveSection(id);
          },
          { root: null, rootMargin: '-45% 0px -45% 0px', threshold: 0.01 }
        );
        observer.observe(el);
        return observer;
      })
      .filter(Boolean);

    return () => observers.forEach((o) => o.disconnect());
    // sectionIds is a module-level constant array; joining keeps the dep stable.
  }, [sectionIds]);

  return activeSection;
};

export default useScrollSpy;
